// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 53 ? "e2279502" : chunkId) + "." + {"53":"b037cb5e9ebc0b48","377":"458480dc985b209c","790":"ccd33cb799e84102"}[chunkId] + ".js";
};